module.exports = __webpack_public_path__ + "static/media/test8_4.e4fe2bb7.png";